import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incident-pinnwand-deaktivieren';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentPinnwandDeaktivierenEffects {

    IncidentPinnwandDeaktivieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENT_PINNWAND_DEAKTIVIEREN),
        mergeMap((x: ac.PostIncidentPinnwandDeaktivierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentPinnwandDeaktivieren(x.incidentRequest).pipe(
                map((result: any) => {
                    return new ac.PostIncidentPinnwandDeaktivierenErfolgreichAction(result, x.incidentRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentPinnwandDeaktivierenFehlerAction(error, x.incidentRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
